// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  view: {
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "borderRadius-kaIpWk": "borderRadius-x1ym1fkr",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "transition-kmkexE": "transition-x1lctnhx",
    "display-k1xSpc": "display-x78zum5",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/selection-and-input/ToggleSwitch.res.js:8"
  },
  viewHoverable: {
    ":hover_borderColor-kaVNsj": "borderColor-x1uctlmt",
    $$css: "wino-gc:src/resources/selection-and-input/ToggleSwitch.res.js:17"
  },
  viewHovered: {
    "borderColor-kVAM5u": "borderColor-x1lkidjr",
    $$css: "wino-gc:src/resources/selection-and-input/ToggleSwitch.res.js:22"
  },
  round: {
    "backgroundColor-kWkggS": "backgroundColor-x1j3d9h6",
    "borderRadius-kaIpWk": "borderRadius-x1xwekrv",
    "bottom-krVfgx": "bottom-x1ey2m1c",
    "left-kbCHJM": "left-x54rlcq",
    "marginBottom-k1K539": "marginBottom-x4ii5y1",
    "marginTop-keoZOQ": "marginTop-xr1yuqi",
    "position-kVAEAm": "position-x10l6tqk",
    "top-k87sOh": "top-x13vifvy",
    $$css: "wino-gc:src/resources/selection-and-input/ToggleSwitch.res.js:25"
  }
};
function viewStyleFromSize(size) {
  if (size === "normal") {
    return {
      height: "26px",
      width: "40px"
    };
  } else {
    return {
      height: "14px",
      width: "25px"
    };
  }
}
function roundStyleFromSize(size) {
  if (size === "normal") {
    return {
      height: "20px",
      width: "20px"
    };
  } else {
    return {
      height: "10px",
      width: "10px"
    };
  }
}
function roundStyleFromParams(value, size) {
  let transform = size === "normal" ? value ? "translateX(14px)" : "translateX(0px)" : value ? "translateX(10px)" : "translateX(0px)";
  if (value) {
    return {
      backgroundColor: "#a01e72",
      transition: "all .15s",
      transform: transform
    };
  } else {
    return {
      transition: "all .15s",
      transform: transform
    };
  }
}
function viewStyleFromParams(disabled) {
  if (disabled) {
    return {
      opacity: 0.4
    };
  } else {
    return {
      opacity: 1
    };
  }
}
function ToggleSwitch(props) {
  let __size = props.size;
  let __hovered = props.hovered;
  let __disabled = props.disabled;
  let onChange = props.onChange;
  let value = props.value;
  let disabled = __disabled !== undefined ? __disabled : false;
  let hovered = __hovered !== undefined ? __hovered : false;
  let size = __size !== undefined ? __size : "normal";
  let newrecord = {
    ...Stylex.props(styles.view, viewStyleFromSize(size), viewStyleFromParams(disabled), disabled ? {} : styles.viewHoverable, !disabled && hovered ? styles.viewHovered : {})
  };
  let view = JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx("div", Stylex.props(styles.round, roundStyleFromSize(size), roundStyleFromParams(value, size))), newrecord));
  if (onChange !== undefined) {
    return JsxRuntime.jsx(Touchable.make, {
      children: view,
      disabled: disabled,
      onPress: param => onChange(!value)
    });
  } else {
    return view;
  }
}
let make = ToggleSwitch;
export { make };
/* styles Not a pure module */